import React from 'react'

import ModalHeader from '@/modules/Cart/shared/ModalHeader/ModalHeader'
import { Box, Center, Loader } from '@mantine/core'

export const InitializingTitle = () => {
    const metadata = {
        title: 'Initialisation',
        description: "Création d'une session sécurisée en cours...",
    }
    return <ModalHeader {...metadata} />
}
export const Initializing = () => {
    return (
        <Center className="h-full">
            <Loader size="sm" color="dark" />
        </Center>
    )
}
